// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.container[data-v-81941774] {
  display: flex;
}
.container > div[data-v-81941774] {
  padding-left: 1rem;
  padding-right: 1rem;
}
.ui-button[data-v-81941774] {
  margin: 1rem 0.5rem 0;
}
img[data-v-81941774] {
  width: 100%;
}
p > span[data-v-81941774] {
  display: block;
  margin-top: 0.5rem;
}
.mobile-app .container[data-v-81941774] {
  flex-direction: column;
}
.mobile-app .containers > div[data-v-81941774] {
  margin-left: auto;
  margin-right: auto;
  max-width: 25rem;
}
.pop-up-btn[data-v-81941774] {
  display: flex;
  margin-top: 1rem;
}
@media screen and (max-width: 48rem) {
.desktop-app .container[data-v-81941774] {
    flex-direction: column;
}
.desktop-app .container > div[data-v-81941774] {
    margin-left: auto;
    margin-right: auto;
    max-width: 25rem;
}
}
@media screen and (min-width: 48.0625rem) {
.desktop-app .containers > div[data-v-81941774] {
    width: 50%;
    margin-top: auto;
    margin-bottom: auto;
}
}
.right-section[data-v-81941774] {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 22rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/popUp/CloseIdvProcess.vue"],"names":[],"mappings":";AAoEA;EACA,aAAA;AACA;AAEA;EACA,kBAAA;EACA,mBAAA;AACA;AAEA;EACA,qBAAA;AACA;AAEA;EACA,WAAA;AACA;AAEA;EACA,cAAA;EACA,kBAAA;AACA;AAEA;EACA,sBAAA;AACA;AAEA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AACA;AAEA;EACA,aAAA;EACA,gBAAA;AACA;AAEA;AACA;IACA,sBAAA;AACA;AAEA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;AACA;AACA;AAEA;AACA;IACA,UAAA;IACA,gBAAA;IACA,mBAAA;AACA;AACA;AAEA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AACA","sourcesContent":["<template>\n  <div>\n    <div class=\"container\">\n      <div>\n        <img :src=\"imageSource\" />\n      </div>\n      <div class=\"right-section\">\n        <p>\n          {{ $t('Error.Description.CloseIdvProcess') }}\n        </p>\n        <div class=\"pop-up-btn\">\n          <ui-button\n            :label=\"buttonLabel\"\n            :loading=\"isLoading\"\n            additional\n            @click=\"redirect()\"\n          />\n          <ui-button\n            :label=\"continueButtonLabel\"\n            :disabled=\"isLoading\"\n            @click=\"$emit('click')\"\n          />\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport { redirectFailure } from '@src/scripts/routerManager'\nimport { mapMutations } from 'vuex'\nimport mutations from '@src/store/mutations'\n\nexport default {\n  props: {\n    buttonLabel: { type: String, default: undefined, required: true },\n    continueButtonLabel: { type: String, default: undefined, required: true }\n  },\n\n  data() {\n    return {\n      isLoading: false\n    }\n  },\n\n  computed: {\n    hasPermissionsRedirect() {\n      const { session } = this.$store.state\n      return !!(session && session.hasPermissionsRedirect)\n    },\n\n    imageSource() {\n      return '/public/images/close-process.png'\n    }\n  },\n\n  methods: {\n    ...mapMutations([mutations.updateOmnichannelStatus]),\n\n    async redirect() {\n      this.isLoading = true\n      await redirectFailure()\n    }\n  }\n}\n</script>\n\n<style scoped>\n.container {\n  display: flex;\n}\n\n.container > div {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.ui-button {\n  margin: 1rem 0.5rem 0;\n}\n\nimg {\n  width: 100%;\n}\n\np > span {\n  display: block;\n  margin-top: 0.5rem;\n}\n\n.mobile-app .container {\n  flex-direction: column;\n}\n\n.mobile-app .containers > div {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 25rem;\n}\n\n.pop-up-btn {\n  display: flex;\n  margin-top: 1rem;\n}\n\n@media screen and (max-width: 48rem) {\n  .desktop-app .container {\n    flex-direction: column;\n  }\n\n  .desktop-app .container > div {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 25rem;\n  }\n}\n\n@media screen and (min-width: 48.0625rem) {\n  .desktop-app .containers > div {\n    width: 50%;\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n}\n\n.right-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 22rem;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
